import StaticCrumb from '../components/StaticCrumb';
import SkillCrumb from '../components/SkillCrumb';
import SkillFileCrumb from '../components/SkillFileCrumb';
import { BreadcrumbRouteConfig } from '../types';

export const skillsRoutes: BreadcrumbRouteConfig = {
    path: '/agents/:agentId/skills',
    breadcrumbs: [
        {
            component: StaticCrumb,
            props: {
                label: 'Skills',
                href: '/agents/:agentId/skills',
            },
        },
    ],
    children: [
        {
            path: ':skillId',
            breadcrumbs: [
                {
                    component: SkillCrumb,
                    props: { param: 'skillId' },
                },
            ],
            children: [
                {
                    path: 'file/:fileId',
                    breadcrumbs: [
                        {
                            component: SkillFileCrumb,
                            props: {
                                skillParam: 'skillId',
                                fileParam: 'fileId',
                                isCurrentPage: true,
                            },
                        },
                    ],
                },
            ],
        },
    ],
};
